__turbopack_context__.v({
  "bold": "ReusableFullWidthText-module__njaJwq__bold",
  "center": "ReusableFullWidthText-module__njaJwq__center",
  "codeBlock": "ReusableFullWidthText-module__njaJwq__codeBlock",
  "content": "ReusableFullWidthText-module__njaJwq__content",
  "copyButton": "ReusableFullWidthText-module__njaJwq__copyButton",
  "highlight": "ReusableFullWidthText-module__njaJwq__highlight",
  "inlineCode": "ReusableFullWidthText-module__njaJwq__inlineCode",
  "italic": "ReusableFullWidthText-module__njaJwq__italic",
  "left": "ReusableFullWidthText-module__njaJwq__left",
  "list": "ReusableFullWidthText-module__njaJwq__list",
  "listItem": "ReusableFullWidthText-module__njaJwq__listItem",
  "paragraph": "ReusableFullWidthText-module__njaJwq__paragraph",
  "strikethrough": "ReusableFullWidthText-module__njaJwq__strikethrough",
  "underline": "ReusableFullWidthText-module__njaJwq__underline",
});
